import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-FormPostulanteReactivo',
  templateUrl: './FormPostulanteReactivo.component.html',
  styleUrls: ['./FormPostulanteReactivo.component.css']
})
export class FormPostulanteReactivoComponent implements OnInit {

  // registrationForm = new FormGroup({
  //   userName: new FormControl('ZhypeR'),
  //   password: new FormControl(''),
  //   confirmPassword: new FormControl(''),
  //   address: new FormGroup({
  //     city: new FormControl('Cusco'),
  //     state: new FormControl(''),
  //     postalCode: new FormControl('')
  //   })
  // });

  constructor(
    private fb: FormBuilder
  ) { }

  registrationForm = this.fb.group({
    userName: ['ZhypeR', Validators.required],
    email: [''],
    suscribe: [false],
    password: [''],
    confirmPassword: [''],
    address: this.fb.group({
      city: ['Cujco'],
      state: [''],
      postalCode: ['']
    })
  });
  
  ngOnInit() {
  }

}
